module.exports = __webpack_public_path__ + "static/img/file_img.bf73a4ed.jpg";